import Badge from '../common/Badge';

export default function ProductCard({ product, index }) {
  const delay = (index % 6) * 100;

  return (
    <div
      className="card relative flex flex-col p-6 hover:-translate-y-1 cursor-default animate-fade-up"
      style={{ animationDelay: `${delay}ms`, animationFillMode: 'both' }}
    >
      {/* Top color accent bar */}
      <div className={`absolute top-0 left-0 right-0 h-1 rounded-t-2xl bg-gradient-to-r ${product.color}`} />

      {/* Icon circle */}
      <div
        className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl mb-4 bg-gradient-to-br ${product.color} bg-opacity-10 shadow-sm`}
        style={{ background: 'linear-gradient(135deg, #eff6ff, #dbeafe)' }}
      >
        {product.icon}
      </div>

      {/* Badges row */}
      <div className="flex gap-2 flex-wrap mb-2">
        <Badge variant="default">{product.category}</Badge>
        {product.badge && <Badge variant={product.badge.toLowerCase()}>{product.badge}</Badge>}
      </div>

      {/* Name */}
      <h3 className="font-display text-lg font-bold text-primary-800 mb-1">
        {product.name}
      </h3>

      {/* Tagline */}
      <p className="text-accent-dark text-xs font-semibold mb-2">{product.tagline}</p>

      {/* Description */}
      <p className="text-slate-500 text-sm leading-relaxed flex-1">{product.description}</p>

      {/* Flavors */}
      {product.flavors && (
        <p className="text-slate-400 text-xs mt-3 italic">{product.flavors}</p>
      )}

      {/* Product number */}
      <div className="absolute bottom-4 right-4 text-slate-200 font-display font-bold text-3xl select-none">
        {String(product.id).padStart(2, '0')}
      </div>
    </div>
  );
}
